import { defineComponent as s, openBlock as a, createElementBlock as o, mergeProps as d, unref as e, renderSlot as i, createElementVNode as m, createCommentVNode as p } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, f = { key: 1 }, M = { key: 2 }, h = { key: 3 }, k = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconDotsThreeOutlineVertical"
}, v = /* @__PURE__ */ s({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(n) {
    const A = n, { bind: Z, weight: l } = u(A);
    return (r, t) => (a(), o("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(Z)), [
      i(r.$slots, "default"),
      e(l) === "bold" ? (a(), o("g", g, t[0] || (t[0] = [
        m("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,40a8,8,0,1,1,8-8A8,8,0,0,1,128,136Zm0-56A32,32,0,1,0,96,48,32,32,0,0,0,128,80Zm0-40a8,8,0,1,1-8,8A8,8,0,0,1,128,40Zm0,136a32,32,0,1,0,32,32A32,32,0,0,0,128,176Zm0,40a8,8,0,1,1,8-8A8,8,0,0,1,128,216Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (a(), o("g", f, t[1] || (t[1] = [
        m("path", {
          d: "M152,128a24,24,0,1,1-24-24A24,24,0,0,1,152,128ZM128,72a24,24,0,1,0-24-24A24,24,0,0,0,128,72Zm0,112a24,24,0,1,0,24,24A24,24,0,0,0,128,184Z",
          opacity: "0.2"
        }, null, -1),
        m("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144Zm0-64A32,32,0,1,0,96,48,32,32,0,0,0,128,80Zm0-48a16,16,0,1,1-16,16A16,16,0,0,1,128,32Zm0,144a32,32,0,1,0,32,32A32,32,0,0,0,128,176Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,224Z" }, null, -1)
      ]))) : e(l) === "fill" ? (a(), o("g", M, t[2] || (t[2] = [
        m("path", { d: "M156,128a28,28,0,1,1-28-28A28,28,0,0,1,156,128ZM128,76a28,28,0,1,0-28-28A28,28,0,0,0,128,76Zm0,104a28,28,0,1,0,28,28A28,28,0,0,0,128,180Z" }, null, -1)
      ]))) : e(l) === "light" ? (a(), o("g", h, t[3] || (t[3] = [
        m("path", { d: "M128,98a30,30,0,1,0,30,30A30,30,0,0,0,128,98Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,128,146Zm0-68A30,30,0,1,0,98,48,30,30,0,0,0,128,78Zm0-48a18,18,0,1,1-18,18A18,18,0,0,1,128,30Zm0,148a30,30,0,1,0,30,30A30,30,0,0,0,128,178Zm0,48a18,18,0,1,1,18-18A18,18,0,0,1,128,226Z" }, null, -1)
      ]))) : e(l) === "regular" ? (a(), o("g", k, t[4] || (t[4] = [
        m("path", { d: "M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144Zm0-64A32,32,0,1,0,96,48,32,32,0,0,0,128,80Zm0-48a16,16,0,1,1-16,16A16,16,0,0,1,128,32Zm0,144a32,32,0,1,0,32,32A32,32,0,0,0,128,176Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,224Z" }, null, -1)
      ]))) : e(l) === "thin" ? (a(), o("g", w, t[5] || (t[5] = [
        m("path", { d: "M128,100a28,28,0,1,0,28,28A28,28,0,0,0,128,100Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,128,148Zm0-72a28,28,0,1,0-28-28A28,28,0,0,0,128,76Zm0-48a20,20,0,1,1-20,20A20,20,0,0,1,128,28Zm0,152a28,28,0,1,0,28,28A28,28,0,0,0,128,180Zm0,48a20,20,0,1,1,20-20A20,20,0,0,1,128,228Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  v as default
};
